module.exports = __webpack_public_path__ + "img/builder-30.46d2c06f.webp";